import { clockLabel, dateLabel } from './Shared';

export default function EmployeeChoices({ employees, value, onChange, actions }) {
 return <div className="member-grid employee-choices">{employees.map(person=><div className="employee-choice-card" key={person.id}>
  <label className="member-choice">
   <input type="checkbox" checked={value.includes(person.id)} disabled={person.disabled} onChange={event=>onChange(event.target.checked?[...value,person.id]:value.filter(id=>id!==person.id))}/>
   <span><strong>{person.name}</strong><small>{[person.employment_label,person.team_name].filter(Boolean).join(' · ')}</small>
    {person.schedule_context?.map(item=><span className="employee-state busy" key={item.revision_id}>
     <span><b>{dateLabel(item.date)}</b> · {item.state_label}</span>
     <span>{[item.shift_name,item.start?`${clockLabel(item.start)}${item.end?`–${clockLabel(item.end)}${item.overnight?' (+1 day)':''}`:' · End not set'}`:null,item.team_name,item.status].filter(Boolean).join(' · ')}</span>
    </span>)}
    {person.detail&&<small className="employee-choice-message">{person.detail}</small>}
   </span>
  </label>
  {actions?.(person.id)}
 </div>)}</div>;
}
